import { render, staticRenderFns } from "./button-options.vue?vue&type=template&id=47d45e78&scoped=true"
import script from "./button-options.vue?vue&type=script&lang=js"
export * from "./button-options.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_eb30a0289a409b0a489ae932e3a15a73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d45e78",
  null
  
)

export default component.exports